import { api } from "./api";

const getNotifications = async(player:string) =>{
    try{
        const query = { "player": player}
        
        const {data} = await api.post('/find/registrationNotCompleted',query)

        if(!Array.isArray(data)){
            return [];
        }else{
            return data;
        }
    }catch(e){
        throw e;
    }
}
const markGenericNotificationRead = async(body:any) =>{
     try{
        const query = [
            {
                "$match": {
                    "id_inscricao": body.id_inscricao,
                    "player": body.rawPlayer
                }
            }
        ]

        const {data} = await api.post(`/database/notification_custom__c/aggregate`, query);

        console.log('generic_', data);

        const upNotification = api.put('/database/notification_custom__c',{
            ...data[0],...{read:true}
        })

    }catch(e){
        throw e;
        console.log('error',e);
    }finally{

    }
}

const markReadNotification = async(notificationId:string) =>{
    try{
        const query = [
            {
                "$match":{
                    "_id":notificationId
                }
            }
        ]

        const {data} = await api.post(`/database/notification_custom__c/aggregate`, query);

        const upNotification = api.put('/database/notification_custom__c',{
            ...data[0],...{read:true}
        })

    }catch(e){
        throw e;
        console.log('error',e);
    }finally{

    }
}
export {
    getNotifications,
    markReadNotification,
    markGenericNotificationRead
}